import {
  FileDashboardSingleViewModel,
  PayMonthStatusEnum,
  PayrollReportStatusEnum,
} from '@fora-monorepo/employer-my-pages-common/types';

export const mockFileDashboardSingle: FileDashboardSingleViewModel = {
  employmentReportStatus: {
    isEmploymentReportProcessing: false,
    latestProcessedReportHasDeviationsAndNoPayrollData: null,
    latestProcessedReportHasInformationAndNoPayrollData: null,
  },
  payMonthsWithDeviations: [
    { payMonth: '202407', reportId: '617B885720731EDF92B21F793EFEABF6', createdDate: '2024-07-24T09:47:32' },
  ],
  payMonthsWithInformation: [
    { payMonth: '202401', reportId: 'EBD11A42D2AD1EDEB2E1B75B70B44BEF', createdDate: '2024-02-14T08:50:32' },
    { payMonth: '202404', reportId: '617B885720731EDF8FBD6EA945DC4BF6', createdDate: '2024-07-09T14:04:56' },
  ],
  unreportedPayMonths: ['202412', '202411', '202410'],
  expiringFaGroups: [],
  employmentReportWithDeviations: {
    hasInformation: false,
    adminReporterFullName: '',
    createdDate: '',
    hasDeviations: true,
    payrollReportId: '',
    source: '',
    status: '',
    successfullyProcessedDate: '',
  },
  employmentReportWithInformation: {
    hasInformation: true,
    adminReporterFullName: '',
    createdDate: '',
    hasDeviations: false,
    payrollReportId: '',
    source: '',
    status: '',
    successfullyProcessedDate: '',
  },
  isAnyReportProcessingForYear: true,
  payMonthOverviewsForYear: [
    {
      payMonth: '202408',
      periodFromDate: '2024-08-01',
      periodToDate: '2024-09-30',
      isPeriodOpen: true,
      payMonthStatus: PayMonthStatusEnum.ReportingNotDone,
      payrollReportHeads: [],
    },
    {
      payMonth: '202311',
      periodFromDate: '2023-11-01',
      periodToDate: '2023-12-31',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportingDelayed,

      payrollReportHeads: [],
    },
    {
      payMonth: '202401',
      periodFromDate: '2024-01-01',
      periodToDate: '2024-03-31',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportProcessing,

      payrollReportHeads: [
        {
          payrollReportId: '1754BE49256E1EDF80F4FD2C6A882BF0',
          source: 'CERN',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: true,
          hasEmploymentDeviations: true,
          hasEmploymentInformation: false,
          createdDate: '2024-04-26T10:35:18',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEB2E4180B58A52BEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-02-14T11:06:43',
          successfullyProcessedDate: '2024-07-09T11:53:12',
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEB2E416B9108B4BEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-02-14T11:06:24',
          successfullyProcessedDate: '2024-07-09T11:52:51',
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEB2E1D2667E8CCBEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-02-14T08:56:35',
          successfullyProcessedDate: '2024-07-09T11:53:12',
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEB2E1D0CEE8288BEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-02-14T08:56:14',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEB2E1B8D9AC0A2BEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-02-14T08:50:52',
          successfullyProcessedDate: '2024-07-09T11:53:32',
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEB2E1B75B70B44BEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-02-14T08:50:32',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: true,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEB1E66051BF61CBEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-02-09T11:07:19',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEB1E66051BF64EBEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-02-09T11:07:19',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEAEA163BAE603CBEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-01-22T10:46:29',
          successfullyProcessedDate: '2024-07-09T11:53:32',
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEADA8A84C2A438BEF',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-01-17T15:32:36',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202401',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: null,
        },
      ],
    },
    {
      payMonth: '202402',
      periodFromDate: '2024-02-01',
      periodToDate: '2024-03-31',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportProcessing,
      payrollReportHeads: [
        {
          payrollReportId: '37BCEA0B17CA1EDEB88B7574F6682BF0',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-03-12T11:31:22',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202402',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
      ],
    },
    {
      payMonth: '202312',
      periodFromDate: '2023-12-01',
      periodToDate: '2024-01-31',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportProcessing,
      payrollReportHeads: [
        {
          payrollReportId: '53C8D084888B1EDF99A5AD0F28A58BF6',
          source: 'CERN',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-08-28T13:05:17',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202312',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: '53C8D084888B1EDF99A5812D4D32EBF6',
          source: 'CERN',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-08-28T12:55:28',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202312',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: '0F0BC7889B2F1EDEBCE7AA8733E06BF0',
          source: 'CERN',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-04-05T13:12:02',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202312',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: 'EBD11A42D2AD1EDEAD8E9D1FEACE4BEF',
          source: 'CERN',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-01-16T14:41:11',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202312',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: '0FE9F49C78C61EDEA7B4C79746E6CBEF',
          source: 'CERN',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2023-12-18T14:06:20',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202312',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: null,
        },
        {
          payrollReportId: '0FE9F49C78C61EDEA7B41B4015FB8BEF',
          source: 'CERN',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2023-12-18T13:27:47',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202312',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
      ],
    },
    {
      payMonth: '202310',
      periodFromDate: '2023-10-01',
      periodToDate: '2023-11-30',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportingDelayed,
      payrollReportHeads: [],
    },
    {
      payMonth: '202406',
      periodFromDate: '2024-06-01',
      periodToDate: '2024-07-31',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportProcessing,
      payrollReportHeads: [
        {
          payrollReportId: '617B885720731EDF8FBD1B12CC460BF6',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-07-09T13:46:14',
          successfullyProcessedDate: '2024-07-09T11:53:23',
          payMonths: [
            {
              payMonth: '202406',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
      ],
    },
    {
      payMonth: '202404',
      periodFromDate: '2024-04-01',
      periodToDate: '2024-05-31',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportingApproved,
      payrollReportHeads: [
        {
          payrollReportId: '617B885720731EDF8FBD6EA945DC4BF6',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSED,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: true,
          createdDate: '2024-07-09T14:04:56',
          successfullyProcessedDate: '2024-07-09T12:09:11',
          payMonths: [
            {
              payMonth: '202404',
              hasDeviations: false,
              hasInformation: true,
            },
          ],
          adminReporterFullName: 'Fora',
        },
      ],
    },
    {
      payMonth: '202308',
      periodFromDate: '2023-08-01',
      periodToDate: '2023-09-30',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportingDelayed,
      payrollReportHeads: [],
    },
    {
      payMonth: '202405',
      periodFromDate: '2024-05-01',
      periodToDate: '2024-06-30',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportingDelayed,
      payrollReportHeads: [],
    },
    {
      payMonth: '202407',
      periodFromDate: '2024-07-01',
      periodToDate: '2024-08-31',
      isPeriodOpen: true,
      payMonthStatus: PayMonthStatusEnum.ReportWithDeviations,
      payrollReportHeads: [
        {
          payrollReportId: '617B885720731EDF92B21F793EFEABF6',
          source: 'Extern',
          status: PayrollReportStatusEnum.PROCESSED,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-07-24T09:47:32',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202407',
              hasDeviations: true,
              hasInformation: false,
            },
          ],
          adminReporterFullName: null,
        },
        {
          payrollReportId: '617B885720731EDF92A7911B1E33ABF6',
          source: 'Extern',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-07-23T23:43:02',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202407',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: null,
        },
        {
          payrollReportId: '617B885720731EDF90D0D09C977CABF6',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-07-15T10:44:59',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202407',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: '617B885720731EDF8FBD2275A57DABF6',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSED,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-07-09T13:47:53',
          successfullyProcessedDate: '2024-07-09T11:52:37',
          payMonths: [
            {
              payMonth: '202407',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
      ],
    },
    {
      payMonth: '202403',
      periodFromDate: '2024-03-01',
      periodToDate: '2024-04-30',
      isPeriodOpen: false,
      payMonthStatus: PayMonthStatusEnum.ReportingApproved,
      payrollReportHeads: [
        {
          payrollReportId: '1754BE49256E1EDF81D94E88CBF9EBF0',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSED,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-04-30T10:20:07',
          successfullyProcessedDate: '2024-07-09T11:52:33',
          payMonths: [
            {
              payMonth: '202403',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: '0F0BC7889B2F1EDEBAD6836FB7BDABF0',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-03-25T15:29:37',
          successfullyProcessedDate: '2024-07-09T11:52:42',
          payMonths: [
            {
              payMonth: '202403',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: '0F0BC7889B2F1EDEB9A7647D1D33CBF0',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-03-18T16:21:06',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202403',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
        {
          payrollReportId: '37BCEA0B17CA1EDEB88BCA99E6864BF0',
          source: 'FORA',
          status: PayrollReportStatusEnum.PROCESSING,
          hasEmploymentData: false,
          hasEmploymentDeviations: false,
          hasEmploymentInformation: false,
          createdDate: '2024-03-12T11:50:24',
          successfullyProcessedDate: null,
          payMonths: [
            {
              payMonth: '202403',
              hasDeviations: false,
              hasInformation: false,
            },
          ],
          adminReporterFullName: 'Fora',
        },
      ],
    },
  ],
};
